import React, {useState, useEffect} from 'react';
import {sendEvarData, logPageLoadEvents} from '@ibibo/analytics';
import FileUploaded from '../FileUploaded/FileUploaded';
import FileLoader from '../FileUploader/FileUploader';
import PassportTooltip from '../PassportTooltip/PassportTooltip';
import Spinner from '../Spinner/Spinner';
import TextInput from '../TextInput/TextInput';
import TradingLicenseDetails from '../TradingLicenseDetails/TradingLicenseDetails';
import UploadedFiles from '../UploadedFiles/UploadedFiles';
import {submitLicenseDetails} from '../../../../../store/actions/thunk';
import PassportTooltipImage from '../assets/passport.png';

import * as S from './Steps.styles';

const Step1 = ({
  setFileData,
  approveFileHandler,
  isLoading,
  setIsLoading,
  responseData,
  setTrnNumber,
  licenseNumber,
  setLicenseNumber,
  approve,
  busineesDetails,
  setBusinessDetails,
  disabledInput,
  setDisabledInput,
  setApprove,
}) => {
  const winSize = window.screen.width;

  const [filePath, setFilePath] = useState('');
  const [fileType, setFileType] = useState('');
  const [tooltip, setTooltip] = useState(true);
  const [fileSize, setFileSize] = useState(0);
  const [imageSizeExceededError, setImageSizeExceededError] = useState('');
  const [fileName, setFileName] = useState('');

  const closeTooltip = () => setTooltip(false);

  const getFileInfo = info => {
    setFileSize(info[0]?.size);
    setFileType(info[0].type);
  };

  const selectFile = (val, fileContent) => {
    setFileName(fileContent?.name);
    setFilePath(val);
    setFileData(fileContent);
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:businessdetails|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/upload-license',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_upload',
    });
  };

  const onApprove = (uploadAgain = false) => {
    if (!uploadAgain) {
      logPageLoadEvents('onboarding:signup:landing', {
        eVar15: 'onboarding:businessdetails|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/upload-license',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
        prop54: 'myPartner_onboarding_uploadApprove',
      });
    }
    approveFileHandler();
  };

  const onClose = () => {
    setApprove(false);
    setDisabledInput(false);
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:businessdetails|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/upload-license',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_uploadRemove',
    });
  };

  return (
    <S.StepCont>
      <S.Heading>Create myPartner Account</S.Heading>
      <S.SubHeading>Tell us a little bit about your business</S.SubHeading>
      <TextInput
        labelText={'License Number'}
        placeholder="License Number"
        classes={'appendTop30'}
        mobileNumber={false}
        setterFunction={setLicenseNumber}
        name={'licenseNumber'}
        component={'licenseNumber'}
        setterObj={licenseNumber}
        disabled={disabledInput}
      />
      <S.TopContent>
        <S.TopContentLft>
          <S.TopContentTitle>Upload Trading License</S.TopContentTitle>
          <S.TopContentSubTitle>
            Ensure that the image isn't blurred and{' '}
            <span>the details including Agency License Number & Business Description</span> are
            clear.
          </S.TopContentSubTitle>
        </S.TopContentLft>
        <S.TopContentRht>
          {!isLoading && approve ? (
            <FileUploaded closeIcon={true} title={fileName} fileSize={''} onClose={onClose} />
          ) : (
            <React.Fragment>
              <FileLoader
                fileTypes={['.png, .jpeg, .pdf']}
                onFileSelect={selectFile}
                getFileInfo={getFileInfo}
                setImageSizeExceededError={setImageSizeExceededError}
              >
                <p className="font10">
                  Upload <span className="latoBold">Trading License</span>
                </p>
                <p className="font10">PDF, JPEG Only | Below 5MB</p>
              </FileLoader>
              {filePath && (
                <p className="font11 greyText appendTop5">
                  By proceeding, you agree to MakeMyTrip's T&Cs and Privacy Policy
                </p>
              )}
            </React.Fragment>
          )}
          {imageSizeExceededError && <S.ErrorMsg>{imageSizeExceededError}</S.ErrorMsg>}
        </S.TopContentRht>
      </S.TopContent>
      {filePath && !isLoading && !approve && (
        <UploadedFiles
          fileType={fileType}
          filePath={filePath}
          fileTypes={['.png, .jpeg, .pdf']}
          onFileSelect={selectFile}
          getFileInfo={getFileInfo}
          onApprove={onApprove}
        />
      )}
      {isLoading && (
        <S.SpinnerCont>
          <Spinner
            width={winSize >= 768 ? '60px' : '32px'}
            height={winSize >= 768 ? '60px' : '32px'}
            borderWidth={winSize >= 768 ? '8px' : '4px'}
          />
        </S.SpinnerCont>
      )}
      {!isLoading && approve && (
        <TradingLicenseDetails
          responseData={responseData}
          setTrnNumber={setTrnNumber}
          busineesDetails={busineesDetails}
          setBusinessDetails={setBusinessDetails}
        />
      )}
    </S.StepCont>
  );
};

export default Step1;
